import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";

const Introduce = ({
  src,
  backgroundColor,
  alt,
  childrenIsWrapped,
  childrenWrapperStyle,
  wrapperStyle,
  children,
}) => {
  return (
    <Wrapper style={{ backgroundColor, ...wrapperStyle }}>
      <img className="title_img" src={src} alt={alt} />
      {childrenIsWrapped ? (
        <div style={childrenWrapperStyle}>{children}</div>
      ) : (
        children
      )}
    </Wrapper>
  );
};

export default Introduce;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  > .title_img {
    margin-top: 24px;
    width: 305px;
  }
  ${breakpoint("desktop")`
    > .title_img {
      margin-top: 66px;
      width: 642px;
    }
  `}
`;
